export const COLORES_PRODUCTOS = {
    butano: { fila: "#BBDEFB", total: "#90CAF9" },
    propano: { fila: "#FFE0B2", total: "#FFCC80" },
    bso: { fila: "#C8E6C9", total: "#A5D6A7" },
    propelente: { fila: "#E1BEE7", total: "#CE93D8" },
};